import axios from 'axios'

const BASE_URL = (process.env.VUE_APP_API_URL || 'https://fidmarket.fr/api').replace(/\/$/, '')

const adminApi = axios.create({
    baseURL: `${BASE_URL}/admin`,
    timeout: 10000,
})

adminApi.interceptors.request.use(config => {
    const token = localStorage.getItem('admin_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
})

adminApi.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('admin_token')
            window.location.href = '/admin'
        }
        return Promise.reject(error)
    }
)

export default adminApi
